import PropTypes from "prop-types";

import { useOutletApi } from "../../authentication";
import { useSnackbar } from "../../ui";
import { ExpenseFormDialog } from "../expense-form-dialog";

import { Button } from "@mui/material";
import { getErrorMessage } from "@/features/shared";

export const AddExpenseFormDialog = ({ onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();
  // No outlet selector on this form — the expense is recorded for the current
  // outlet (useOutletApi defaults to it).
  const outletApi = useOutletApi();

  const handleSubmit = async ({
    transactionDate,
    expenseCategoryId,
    amount,
    note,
    attachmentPath,
  }) => {
    try {
      await outletApi.post("expenses", {
        transactionDate,
        expenseCategoryId,
        amount,
        note,
        attachmentPath,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal menyimpan data")
      );
    }
  };

  return (
    <ExpenseFormDialog
      onClose={onClose}
      dialogTitle="Tambah Biaya"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddExpenseFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
